'use client';

import { Button } from '@fastfive-dev/fastfive-design-system/components';
import Link from 'next/link';

import { ErrorPageSection } from './ErrorPageSection';

/** 시안 버튼 폭 — 데스크톱 132, 그 미만 192. */
const ACTION_WIDTH = 'desktop:w-132 w-192';

type Props = {
  /** `error.tsx` 의 reset — 에러 바운더리를 다시 렌더해 재시도한다. */
  onRetry: () => void;
};

/** 글로벌 500 본문. */
export function ErrorSection({ onRetry }: Props) {
  return (
    <ErrorPageSection
      // 시안: 데스크톱 한 줄, 그 미만 두 줄.
      title={
        <>
          일시적인 오류가<br className="desktop:hidden" /> 발생했습니다
        </>
      }
      description={
        <>
          서비스 이용에 불편을 드려 죄송합니다.
          <br />
          잠시 후 다시 시도해 주세요.
        </>
      }
      actions={
        <>
          <Button size="large" className={ACTION_WIDTH} onClick={onRetry}>
            다시 시도
          </Button>
          {/* stroke 는 테두리만 덧입힐 뿐 배경을 지우지 않는다. 아웃라인 버튼은
              color="white"(흰 배경) 와 함께 써야 한다. */}
          <Button
            asChild
            size="large"
            color="white"
            stroke
            className={ACTION_WIDTH}
          >
            <Link href="/">홈으로</Link>
          </Button>
        </>
      }
    />
  );
}
